module.exports = __webpack_public_path__ + "img/icon1.86ccfd03.png";